import React from 'react'
import './App.css'
import { Link, Redirect } from 'react-router-dom'
import Axios from 'axios'
import Footer from './components/Footer'
import GooglePlacesAutocomplete from 'react-google-places-autocomplete'
import {
  IoIosContact,
  IoIosCalendar,
  IoIosBarcode,
  IoIosCard,
  IoMdHeartEmpty,
  IoMdPerson,
  IoIosLock,
  IoIosPaper,
  IoIosInformationCircleOutline,
  IoIosLogOut,
  IoIosRemoveCircleOutline,
  IoIosCheckmarkCircleOutline,
  IoIosArrowBack,
} from 'react-icons/io'
import { RiCheckboxBlankLine, RiCheckboxFill, RiEditLine } from 'react-icons/ri'
import ClipLoader from 'react-spinners/ClipLoader'
import Header3 from './components/Header3'
import { BiMenu } from 'react-icons/bi'
import Header5 from './components/Header5'
import SideNav from './layouts/SideNav'
import Header from './layouts/Header'
import SideNavCust from './layouts/SideNavCust'
import { API_URL } from './config'

class Updateeventdetails extends React.Component {
  constructor(props) {
    super(props)
    const isMobile = window.innerWidth <= 768
    this.state = {
      query: '',
      password: '',
      response: '',
      error: '',
      successError: '',
      errorDisplay: 'none',
      businessname: localStorage.getItem('businessname'),
      eventname: this.props.location.state.eventname,
      customOrganiserName: this.props.location.state.customOrganiserName,
      eventdate: this.props.location.state.eventdate,
      eventid: this.props.location.state.eventid,
      poster: this.props.location.state.poster,
      theme: this.props.location.state.theme,
      venue: this.props.location.state.venue,
      expectednum: 0,
      enddate: this.props.location.state.enddate,
      time: this.props.location.state.time,
      endtime: this.props.location.state.endtime,
      event_date: this.props.location.state.event_date,
      finish_date: this.props.location.state.finish_date,
      description: 'Coming soon...',
      spinning: 'none',
      updateDisplay: 'block',
      saveBtn: 'save-btn',
      loader: true,
      allowRefund: 0,
      refundPolicyLocked: 0,
      isMobile,
      collapsed: isMobile,
    }
  }

  componentDidMount() {
    this.updateIsMobile()
    window.addEventListener('resize', this.updateIsMobile)
    const eventid = this.props.location.state.eventid

    const businessname = localStorage.getItem('businessname')
    const businessid = localStorage.getItem('businessid')
    document.title = businessname + ' - Edit '

    Axios.get(
      `${API_URL}/apps/kscanner/webservices.php?query=GET-PRIVATE-EVENT-DETAILS&eventid=${eventid}`,
      { withCredentials: true }
    ).then((response) => {
      this.setState({
        loader: false,
        description: response.data.description,
        eventname: response.data.eventName,
        customOrganiserName: response.data.customOrganiserName,
        venue: response.data.eventLocation,
        theme: response.data.theme,
        expectednum: response.data.numOfAttendees,
        eventdate: response.data.eventDate,
        enddate: response.data.endDate,
        time: response.data.startTime,
        endtime: response.data.endTime,
        finish_date: response.data.endDate,
        event_date: response.data.eventDate,
        allowRefund: response.data.refundsAllowed,
        refundPolicyLocked: response.data.refundPolicyLocked,
      })
    })
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateIsMobile)
  }

  updateIsMobile = () => {
    const isMobile = window.innerWidth <= 768
    this.setState((prev) => ({
      isMobile,
      collapsed: isMobile ? true : prev.collapsed, // auto-collapse only when entering mobile
    }))
  }

  handleToggle = () => {
    this.setState((prevState) => ({
      collapsed: !prevState.collapsed,
    }))
  }

  handleEventname = (event) => {
    this.setState({
      eventname: event.target.value,
      errorDisplay: 'none',
    })
  }

  handleOrganiserName = (event) => {
    this.setState({
      customOrganiserName: event.target.value,
      errorDisplay: 'none',
    })
  }

  handleVenue = (e) => {
    // alert(e.target.value);
    this.setState({
      venue: e.target.value,
      errorDisplay: 'none',
    })
  }

  handleTheme = (event) => {
    this.setState({
      theme: event.target.value,
      errorDisplay: 'none',
    })
  }

  handleExpected = (event) => {
    this.setState({
      expectednum: event.target.value,
      errorDisplay: 'none',
    })
  }

  handleDate = (event) => {
    this.setState({
      event_date: event.target.value,
      errorDisplay: 'none',
    })
  }

  handleEnddate = (event) => {
    this.setState({
      finish_date: event.target.value,
      errorDisplay: 'none',
    })
  }

  handleTime = (event) => {
    this.setState({
      time: event.target.value,
      errorDisplay: 'none',
    })
  }

  handleEndtime = (event) => {
    this.setState({
      endtime: event.target.value,
      errorDisplay: 'none',
    })
  }

  handleDescription = (event) => {
    this.setState({
      description: event.target.value,
      errorDisplay: 'none',
    })
  }

  refundSetting = () => {
    if (this.state.allowRefund == 0) {
      this.setState({
        allowRefund: 1,
      })
    } else {
      this.setState({
        allowRefund: 0,
      })
    }
  }

  update = () => {
    const businessid = localStorage.getItem('businessid')
    const eventid = this.props.location.state.eventid
    const accounttype = localStorage.getItem('accounttype')
    const businessname = this.state.businessname
    const eventname = this.state.eventname
    const customOrganiserName = this.state.customOrganiserName
    const venue = this.state.venue
    const theme = this.state.theme
    const expectednum = this.state.expectednum
    const eventdate = this.state.eventdate
    const enddate = this.state.enddate
    const time = this.state.time
    const endtime = this.state.endtime
    const description = this.state.description
    const finish_date = this.state.finish_date
    const event_date = this.state.event_date
    // alert(venue);

    if (this.state.eventname.trim() === '') {
      this.setState({
        error: 'Please enter event name',
        errorDisplay: 'block',
        successError: 'error-login',
      })
    } else if (this.state.venue.trim() === '') {
      this.setState({
        error: 'Please enter venue',
        errorDisplay: 'block',
        successError: 'error-login',
      })
    } else if (this.state.expectednum <= 0) {
      this.setState({
        error: 'Enter estimated Number of Attendees',
        errorDisplay: 'block',
        successError: 'error-login',
      })
    } else if (event_date === '') {
      this.setState({
        error: 'Enter the event date',
        errorDisplay: 'block',
        successError: 'error-login',
      })
    } else if (finish_date === '') {
      this.setState({
        error: 'Enter the event end date',
        errorDisplay: 'block',
        successError: 'error-login',
      })
    } else if (this.state.time.trim() === '') {
      this.setState({
        error: 'Enter event time',
        errorDisplay: 'block',
        successError: 'error-login',
      })
    } else if (this.state.endtime.trim() === '') {
      this.setState({
        error: 'Enter event end time',
        errorDisplay: 'block',
        successError: 'error-login',
      })
    } else if (this.state.description.trim() === '') {
      this.setState({
        error: 'Enter description',
        errorDisplay: 'block',
        successError: 'error-login',
      })
    } else {
      this.setState({
        updateDisplay: 'none',
        spinning: 'block',
        saveBtn: 'btn-disabled',
      })
      const data = new FormData()
      data.append('query', 'ADDEVENT')
      data.append('subquery', 'UPDATEEVENT')
      data.append('eventid', eventid)
      data.append('visa', '1')
      data.append('cash', '0')
      data.append('accountid', businessid)
      data.append('event', eventname)
      data.append('customOrganiserName', customOrganiserName)
      data.append('venue', venue)
      data.append('theme', theme)
      data.append('expected', expectednum)
      data.append('startdate', event_date)
      data.append('enddate', finish_date)
      data.append('starttime', time)
      data.append('endtime', endtime)
      data.append('description', description)
      data.append('refunds_allowed', this.state.allowRefund)

      Axios.post(`${API_URL}/apps/kscanner/webservices.php`, data, {
        withCredentials: true,
      })
        .then((response) => {
          if (response.data.status === 'success') {
            this.setState({
              updateDisplay: 'block',
              spinning: 'none',
              saveBtn: 'save-btn',
            })
            this.setState({
              error: response.data.message,
              errorDisplay: 'block',
              successError: 'success-login',
              updateDisplay: 'block',
              spinning: 'none',
            })
          } else {
            // alert(accountype);
            this.setState({
              updateDisplay: 'block',
              spinning: 'none',
              saveBtn: 'save-btn',
            })
            this.setState({
              error: response.data.message,
              errorDisplay: 'block',
              successError: 'error-login',
            })
          }

          setTimeout(() => {
            this.setState({ errorDisplay: 'none' })
          }, 5000)
        })
        .catch(function (error) {
          this.setState({
            updateDisplay: 'block',
            spinning: 'none',
            saveBtn: 'save-btn',
          })
          this.setState({
            error: error,
            errorDisplay: 'block',
            successError: 'error-login',
          })

          setTimeout(() => {
            this.setState({ errorDisplay: 'none' })
          }, 5000)
        })
    }
  }

  handleLocation = () => {
    alert('text')
  }

  render() {
    if (localStorage.getItem('businessname') === null) {
      return <Redirect to="/login" />
      //   return exit(1);
    } else {
    }
    const customername = localStorage.getItem('customername')
    const dtregistered = this.props.location.state.dtregistered

    const prevpage = this.props.location.state.prevpage
    const backpage = this.props.location.state.currentage
    const eventname = this.props.location.state.eventname
    const eventdate = this.props.location.state.eventdate
    const eventid = this.props.location.state.eventid
    const poster = this.props.location.state.poster
    const theme = this.props.location.state.theme
    const venue = this.props.location.state.venue
    const expectednum = this.props.location.state.expectednum
    const enddate = this.props.location.state.enddate
    const time = this.props.location.state.time
    const endtime = this.props.location.state.endtime
    const event_date = this.props.location.state.event_date
    const finish_date = this.props.location.state.finish_date

    const currentVenue = this.state.venue

    const accounttype = localStorage.getItem('accounttype')
    const { collapsed, isMobile } = this.state

    return (
      <div className="view">
        {accounttype === 'customer' ? (
          <>
            {' '}
            <SideNavCust collapsed={this.state.collapsed} onToggle={this.handleToggle} />
            <Header />
          </>
        ) : accounttype === 'business' ? (
          <>
            <SideNav collapsed={this.state.collapsed} onToggle={this.handleToggle} />
            <Header />
          </>
        ) : (
          <Header5 />
        )}
        <div
          className="container"
          style={{
            marginTop: 40,
            marginLeft: this.state.isMobile ? '0px' : this.state.collapsed ? 'auto' : 'auto',
          }}
        >
          {/* ✅ Mobile overlay when sidebar is open */}
          {isMobile && !collapsed && (
            <div className="mobile-overlay active" onClick={this.handleToggle} />
          )}

          {this.state.isMobile && this.state.collapsed && (
            <label className="mobile-toggle" onClick={this.handleToggle}>
              <BiMenu size={25} />
            </label>
          )}
          <div className="row justify-content-center just-container-insid pb-5">
            <div className="col-lg-7">
              <div className=" BoxDashboardContainer mt-5 mb-4 mrgin-search pl-0 pr-0">
                <div className="row align-self-center justify-content-center">
                  <div className="item-list p-0">
                    <div className="col-lg-4 col-12 pl-0">
                      <button onClick={() => this.props.history.goBack()} className="link-btn">
                        <IoIosArrowBack size={25} />
                        Back &nbsp;
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <div className=" BoxDashboardContainer  pl-0 pr-0">
                <div className="row align-self-center justify-content-center">
                  <div className="item-list p-0">
                    <div className="col-lg-12 pl-0">
                      <label className="ticket-title pl-0 pr-0">EDITING EVENT</label>
                    </div>
                  </div>

                  <div className="h-divider w-100"></div>
                </div>
                <div className={!this.state.loader ? 'd-none' : 'col-12 text-center'}>
                  <ClipLoader size={25} color="grey" />
                </div>
                <div className={this.state.loader ? 'd-none' : 'col-12 details-body'}>
                  <span>Details</span>
                  <br />
                  <br />
                  Event name
                  <br />
                  <input
                    type="text"
                    placeholder="Event name"
                    value={this.state.eventname}
                    onChange={this.handleEventname}
                    className="edit-input form-control"
                  />
                  <br /> <br />
                  Organizer Identity (Custom Input)
                  <br />
                  <input
                    type="text"
                    placeholder="If not set, defaults to account name"
                    value={this.state.customOrganiserName}
                    onChange={this.handleOrganiserName}
                    className="edit-input form-control"
                  />
                  <br /> <br />
                  <label>Venue</label>
                  <br />
                  {/* <GooglePlacesAutocomplete
                    apiKey="AIzaSyDNn7uMQVzoH91NYn7vzX437q5fp8g92FU"
                    styles={{
                      textInputContainer: {
                        backgroundColor: "grey",
                      },
                      textInput: {
                        height: 38,
                        color: "#5d5d5d",
                        fontSize: 16,
                      },
                    }}
                    textInputProps={{
                      onChange: (text) => {
                        this.handleVenue(text);
                      },
                    }}
                    selectProps={{
                      onChange: (data, details = null) =>
                        this.setState({ venue: data["value"]["description"] }),
                      fetchDetails: true,
                      placeholder: "Enter address or zip code",
                      defaultInputValue: this.state.venue,
                    }}
                  /> */}
                  <input
                    type="text"
                    placeholder="Enter your address or zip code"
                    value={this.state.venue}
                    onChange={this.handleVenue}
                    className="edit-input form-control"
                    id="location-search-input"
                  />
                  {/* <div id="map" style={{ display: "none" }}></div> */}
                  <br />
                  Theme
                  <br />
                  <input
                    type="text"
                    placeholder="Theme"
                    value={this.state.theme}
                    onChange={this.handleTheme}
                    className="edit-input form-control"
                  />
                  <br />
                  <br />
                  Estimated Number of Attendees
                  <br />
                  <input
                    type="text"
                    placeholder="Number of expected to attend"
                    value={this.state.expectednum}
                    onChange={this.handleExpected}
                    className="edit-input form-control"
                  />
                  <br />
                  <br />
                  Event date:{' '}
                  {/* <label className="small-details">
                    currently set to {this.state.eventdate}
                  </label> */}
                  <br />
                  <input
                    type="date"
                    placeholder="Set date"
                    value={this.state.event_date}
                    onChange={this.handleDate}
                    className="edit-input form-control"
                  />
                  <br />
                  <br />
                  End date:{' '}
                  {/* <label className="small-details">
                    currently set to {this.state.enddate}
                  </label> */}
                  <br />
                  <input
                    type="date"
                    placeholder="End date"
                    value={this.state.finish_date}
                    onChange={this.handleEnddate}
                    className="edit-input form-control"
                  />
                  <br />
                  <br />
                  Time
                  <br />
                  <input
                    type="time"
                    placeholder="Set time"
                    value={this.state.time}
                    onChange={this.handleTime}
                    className="edit-input form-control"
                  />
                  <br />
                  <br />
                  End time
                  <br />
                  <input
                    type="time"
                    placeholder="End time"
                    value={this.state.endtime}
                    onChange={this.handleEndtime}
                    className="edit-input form-control"
                  />
                  <br />
                  <br />
                  Description
                  <br />
                  <textarea
                    placeholder="Description"
                    value={this.state.description}
                    onChange={this.handleDescription}
                    className="edit-input form-control"
                  />
                  <div className={'w-100 mb-3'} style={{ marginTop: -15 }}>
                    <input
                      type="checkbox"
                      checked={this.state.allowRefund == 1 ? true : false}
                      value={this.state.allowRefund}
                      disabled={this.state.refundPolicyLocked == 1 ? true : false}
                      onChange={this.refundSetting}
                      className="w-auto float-left"
                      id="allow_refund"
                    />
                    &nbsp;
                    <label
                      htmlFor="allow_refund"
                      className={`${
                        this.state.refundPolicyLocked == 1 ? 'text-grey' : 'cursor-pointer'
                      }`}
                      style={{ marginTop: 10 }}
                    >
                      Allow refunds
                    </label>
                    <div
                      className={
                        this.state.refundPolicyLocked == 1
                          ? 'alert alert-warning p-2'
                          : 'alert alert-info p-2'
                      }
                    >
                      {this.state.refundPolicyLocked == 1 ? (
                        <>
                          <span>Refund settings are now locked.</span>
                          <br />
                          Ticket sales have begun, and this setting can no longer be changed.
                          <br />
                          Buyers will follow the refund policy that was in place before the first
                          ticket sale. If no policy was set, this event is treated as{' '}
                          <span>non-refundable</span> by default.
                        </>
                      ) : (
                        <>
                          Refunds are processed through Karamale. This setting determines whether
                          buyers can request refunds. Once ticket sales begin, it becomes final and
                          cannot be changed.
                        </>
                      )}
                    </div>
                  </div>
                  <label className="back-arrow mb-0 bottom__button">
                    <button
                      type="button"
                      className={`${this.state.saveBtn} float-right`}
                      onClick={() => this.update()}
                      disabled={this.state.spinning === 'block' ? true : false}
                    >
                      <span
                        style={{
                          display: this.state.updateDisplay,
                        }}
                      >
                        Save
                      </span>
                      <span
                        style={{
                          display: this.state.spinning,
                        }}
                      >
                        <ClipLoader
                          color={'grey'}
                          loading={true}
                          // css={override}
                          size={20}
                        />
                      </span>
                    </button>
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          className={this.state.successError}
          style={{ display: this.state.errorDisplay, textAlign: 'center' }}
        >
          {this.state.error}
        </div>
        {/* <Footer /> */}
      </div>
    )
  }
}

export default Updateeventdetails
